import React, { Component } from "react";
import "tui-image-editor/dist/tui-image-editor.css";
import ToastUiImageEditor from "tui-image-editor";
import $ from "jquery";
import Axios from "axios";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class PhotoGalleryImageEditor extends Component {
  constructor(props) {
    super(props);
    this.initialState = {
      imageLoadingError: this.props.imageUrl === "" ? true : false,
      loading: true,
      words: "",
      lang: localStorage.getItem("lang"),
      toggle_next_btn_loader: false,
      toggle_finish_btn_loader: false,
    };
    this.state = this.initialState;
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.getLang();
  }

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };

  lang = (word) => {
    const lang = localStorage.getItem("lang");
    const { words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  render() {
    return <TuiImageEditor {...this.props} />;
  }
}

class TuiImageEditor extends React.Component {
  rootEl = React.createRef();
  imageEditorInst = null;
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let normalProperties = {
      cssMaxHeight: 500,
      cssMaxWidth: 700,
      selectionStyle: {
        cornerSize: 20,
        rotatingPointOffset: 70,
      },
      usageStatistics: true,
    };
    let prePopulateProperties = {
      includeUI: {
        loadImage: {
          path: this.props.imageUrl || "",
          name: "p-1",
        },
        theme: {
          // "header.display": 'none',
          "menu.normalIcon.color": "#8a8a8a",
          "menu.activeIcon.color": "#555555",
          "menu.disabledIcon.color": "#434343",
          "menu.hoverIcon.color": "#e9e9e9",
          "submenu.normalIcon.color": "#8a8a8a",
          "submenu.activeIcon.color": "#e9e9e9",
        },
        menu: ["draw"],
        initMenu: "",
        uiSize: {
          width: "100%",
          height: "80%",
        },
        menuBarPosition: "bottom",
      },
      cssMaxHeight: 400,
      cssMaxWidth: 700,
      selectionStyle: {
        cornerSize: 20,
        rotatingPointOffset: 70,
      },
      usageStatistics: true,
    };
    this.imageEditorInst = new ToastUiImageEditor(
      this.rootEl.current,
      prePopulateProperties
    );
    // this.imageEditorInst = new ToastUiImageEditor(this.rootEl.current, normalProperties);
    document.getElementsByClassName(
      "tui-image-editor-header-logo"
    )[0].style.padding = "18px 15px";
    document.getElementsByClassName(
      "tui-image-editor-header-logo"
    )[0].childNodes[1].src = ""
    document.getElementsByClassName(
      "tui-image-editor-header-logo"
    )[0].childNodes[1].style.width = "90px";
    document.getElementsByClassName(
      "tui-image-editor-header-logo"
    )[0].childNodes[1].style.height = "15px";
    document
      .getElementsByClassName("tui-image-editor-controls-buttons")[0]
      .remove();
    document.getElementsByClassName(
      "tui-image-editor-header-buttons"
    )[0].remove()
    var li = document.createElement("div");
    li.innerHTML= "<button class='upload_image_photo_app_gallery'>Ok</button>"
    document.getElementsByClassName('tui-image-editor-submenu-item')[0].getElementsByTagName("li")[2].append(li)
    document.getElementsByClassName("upload_image_photo_app_gallery")[0].addEventListener("click", () => {
      this.props.upload();
    });
    let displayNoneArr = ["history", "deleteAll", "delete", "redo"];
    displayNoneArr.map((className) => {
      if (document.getElementsByClassName(`tie-btn-${className}`)[0]) {
        document.getElementsByClassName(
          `tie-btn-${className}`
        )[0].style.display = "none";
      }
    });

    document.getElementsByClassName(
      "tui-image-editor-help-menu"
    )[0].style.cssText =
      "width: auto; border-radius: 5px; padding: 6px 10px 0 10px;";

      document
        .getElementsByClassName("tui-image-editor-header-logo")[0]
        .remove();
    document.getElementsByClassName("tui-image-editor-item")[3].remove();
    document.getElementsByClassName("tui-image-editor-item")[7].remove();
    this.IEditorPanZoom(this.imageEditorInst);
    this.customeRange(this.imageEditorInst);
    // zoom in zoom out on scroll mouse
  }
  

 IEditorPanZoom = (editor) => {
  var scrollContainer;
  var editorContainer;
  var imageEditor = editor;
  
  // zoom
  var hypo = undefined;
  var pinchLast = 1;
  
  // pan
  var touchStart = {x:0,y:0};
  var panInitial = {top:0,left:0};
  
  // Speed Calc
  var scalc = {
      speed: 0,
      touchCurrent : {x:0,y:0}
  }

  var stime = 200;
  var refTouchX;

  var lastDrawingMode;
  
  //mouse mode
  var mousedown = false;
  var mouseMiddle = false;

      
      scrollContainer = $('.tui-image-editor-wrap');
      editorContainer = $('.tui-image-editor')[0];
      editorContainer.addEventListener('pointerdown', onPointerDown, false);
      editorContainer.addEventListener('touchmove', onTouchMove, false);
      editorContainer.addEventListener('touchend', onTouchEnd, false);
      editorContainer.addEventListener('mousewheel', onMousewheel, false);
      
      
      // not working on desktop (PAN)
      editorContainer.addEventListener('onmousedown', onPointerDown, true);
      editorContainer.addEventListener('onmousemove', onTouchMove, true);
      editorContainer.addEventListener('onmouseup', onTouchEnd, true);
      
      // editorContainer.addEventListener('click', onPointerDown, true);
      
      editorContainer.click = onPointerDown;
      editorContainer.onmousemove = onTouchMove;
      editorContainer.onmouseup = onTouchEnd;
      
    
      // Prevent scroll with wheel
      $('.tui-image-editor-wrap')[0].onwheel = function() { return false; };
      // Prevent overlapping from toolbar
      $('.tui-image-editor-wrap').css('height', 'calc(100% - 150px)');
      
  

  function onPointerDown(event) {
      
      
      touchStart = { x: event.clientX, y : event.clientY};
      scalc.touchCurrent = { x: event.clientX, y : event.clientY};
      mousedown = true;
      if(event.button == 1) mouseMiddle = true;
      
      // ignore on drawing...
      if(isPanDisabled(event)) return;
      
       // save and .setDrawingMode('NORMAL'), on shift pressed 
      if(event.shiftKey || mousedown){
          lastDrawingMode = imageEditor.getDrawingMode();
          imageEditor.startDrawingMode('NORMAL');
          imageEditor._graphics.canvasImage.canvas.selection = false;
      }
      
      // SpeedCalc Timer
      // stracker = setInterval(function(){
      //     refTouchX = scalc.touchCurrent.x;
      // }, stime);


      panInitial = {
          top: scrollContainer.scrollTop(),
          left: scrollContainer.scrollLeft(),
      };
      
  };

  function onTouchMove(event) {
      
      
      // Pinch / Zoom
      if(event.targetTouches){
          if (event.targetTouches.length === 2) {
              var touches = event.targetTouches;
              let hypo1 = Math.hypot((touches[0].pageX - touches[1].pageX), (touches[0].pageY - touches[1].pageY));
              if (hypo === undefined) {
                  hypo = hypo1;
              }
              var pinch = (hypo1 / hypo);
              var diff = pinch - pinchLast;

              // ignore very small movements
              if (Math.abs(diff) < 0.02) {
                  pinchLast = pinch;
                  return;
              }


              scaleCanvas((pinch > pinchLast), diff + 1, event);
              pinchLast = pinch;


          } // PAN
          else if (event.targetTouches.length === 1 && ! isPanDisabled(event)) {
              pan(event);
          }
          
      }else { // mouse
          
           if(!isPanDisabled(event)){
              pan(event);
          }
          
      }

      
  };

  function onTouchEnd(event) {

      hypo = undefined;
      pinchLast = 1;
      mousedown = false;
      mouseMiddle = false;
      
      // restore lastDrawingMode
      if(lastDrawingMode){
          imageEditor.startDrawingMode(lastDrawingMode);
          lastDrawingMode = null;
      }

      if(!isPanDisabled(event)){
          
          // Speed animation
          // clearInterval(stracker);
          scalc.speed = Math.abs((refTouchX - scalc.touchCurrent.x) / stime);
          if(scalc.speed >= 0.2){
              animateSpeed();
          };       
      }
  };
  
  
  function isPanDisabled(event){
      
      if(event && event.shiftKey && mousedown) return false;
      
      if(mouseMiddle) return false; // middle
      
      if(!imageEditor.getDrawingMode) return false; // mock
      
      return imageEditor.getDrawingMode != 'NORMAL';
      
  }
  
  function pan(event){
      
      
      var clientX = event.clientX || event.targetTouches[0].clientX;
      var clientY = event.clientY || event.targetTouches[0].clientY;

      var moveX =  touchStart.x - clientX;
      var moveY =  touchStart.y - clientY;

      scrollContainer.scrollLeft(panInitial.left + moveX);
      scrollContainer.scrollTop(panInitial.top + moveY);

      // Speed
      scalc.touchCurrent.x = clientX;
  }  
  
  /** start animatio using speed (not functional at this time) */
  function animateSpeed(){

      //start = null;
      //window.requestAnimationFrame(step);

      var moveX =  touchStart.x - scalc.touchCurrent.x;
      $(scrollContainer).animate({
          scrollLeft: scrollContainer.scrollLeft() + moveX
        }, 200);

  }
  
  /** zoom from pinch */
  function scaleCanvas(zoomIn, wDelta, e) {
      var imageOriginalSize = {
          width: imageEditor._graphics.canvasImage.width
          , height: imageEditor._graphics.canvasImage.height
      };
           var imageEditorWindow = e.currentTarget;
      // var imageEditorWindow = document.querySelector('#tui-image-editor-container .tui-image-editor');
      var initWidth = imageEditorWindow.style.width;
      var initHeight = imageEditorWindow.style.height;
      var scrollContainerInitial = {
          top: scrollContainer.scrollTop()
          , left: scrollContainer.scrollLeft()
          , height: scrollContainer[0].scrollHeight
          , width: scrollContainer[0].scrollWidth
      };
      // event.targetTouches[0].pageX - event.targetTouches[1].pageX
      var offset = $(imageEditorWindow).offset();
      var mousePosition = {
          top: e.targetTouches[0].clientY - offset.top
          , left: e.targetTouches[0].clientX - offset.left
      };
      var newWidth;
      var newHeight;
      var offsetY;
      var offsetX;
      
      if (zoomIn) {
          newWidth = parseInt(initWidth, 10) * wDelta;
          newHeight = parseInt(initHeight, 10) * wDelta;
          // Limit maximum zoom by image resolution
          // if (newWidth > imageOriginalSize.width || newHeight > imageOriginalSize.height) {
          //     newWidth = imageOriginalSize.width;
          //     newHeight = imageOriginalSize.height;
          // }
      }
      else {
          newWidth = parseInt(initWidth, 10) * wDelta;
          newHeight = parseInt(initHeight, 10) * wDelta;
          // Limit minimum zoom by 0.5 of original container size
          // if (parseInt(imageEditorWindow.dataset.minWidth, 10) * 0.5 > parseInt(newWidth, 10)) {
          //     newWidth = parseInt(imageEditorWindow.dataset.minWidth, 10) * 0.5;
          //     newHeight = parseInt(imageEditorWindow.dataset.minHeight, 10) * 0.5;
          // }
      }
      
      imageEditorWindow.style.width = newWidth + 'px';
      imageEditorWindow.style.height = newHeight + 'px';
      $(imageEditorWindow).find('canvas, .tui-image-editor-canvas-container')
          .css('max-width', imageEditorWindow.style.width)
          .css('max-height', imageEditorWindow.style.height);

      
      // Save initial size of container
      if (imageEditorWindow.dataset.minHeight === undefined) {
          imageEditorWindow.dataset.minHeight = initHeight;
          imageEditorWindow.dataset.minWidth = initWidth;
      }
      // Calculate scroll offset for new position
      offsetY = (scrollContainer[0].scrollHeight - scrollContainerInitial.height) * (mousePosition.top / scrollContainerInitial.height);
      offsetX = (scrollContainer[0].scrollWidth - scrollContainerInitial.width) * (mousePosition.left / scrollContainerInitial.width);
      scrollContainer.scrollTop(scrollContainerInitial.top + offsetY);
      scrollContainer.scrollLeft(scrollContainerInitial.left + offsetX);
      
      e.preventDefault();
      e.stopPropagation();
  };
  
  /** zoom using mouse scroll */
  function onMousewheel(e){
      var imageOriginalSize = {
          width: imageEditor._graphics.canvasImage.width,
          height: imageEditor._graphics.canvasImage.height
        };
        var wDelta = e.wheelDelta || e.originalEvent.deltaY;
        var imageEditorWindow = e.currentTarget;
        var scrollContainer = $('.tui-image-editor-wrap');
        var initWidth = imageEditorWindow.style.width;
        var initHeight = imageEditorWindow.style.height;
        var scrollContainerInitial = {
          top: scrollContainer.scrollTop(),
          left: scrollContainer.scrollLeft(),
          height: scrollContainer[0].scrollHeight,
          width: scrollContainer[0].scrollWidth
        };
        var mousePosition = {
          top: e.clientY - $(imageEditorWindow).offset().top,
          left: e.clientX - $(imageEditorWindow).offset().left
        };
        var newWidth;
        var newHeight;
        var offsetY;
        var offsetX;
        // Zoom step 10%
        if (wDelta > 0) {
          newWidth = parseInt(initWidth, 10) * 1.1;
          newHeight = parseInt(initHeight, 10) * 1.1;
          // Limit maximum zoom by image resolution
          // if (newWidth > imageOriginalSize.width || newHeight > imageOriginalSize.height) {
          //   newWidth = imageOriginalSize.width;
          //   newHeight = imageOriginalSize.height;
          // }
        } else {
          newWidth = parseInt(initWidth, 10) * 0.9;
          newHeight = parseInt(initHeight, 10) * 0.9;
          // Limit minimum zoom by 0.5 of original container size
          // if (parseInt(imageEditorWindow.dataset.minWidth, 10) * 0.5 > parseInt(newWidth, 10)) {
          //   newWidth = parseInt(imageEditorWindow.dataset.minWidth, 10) * 0.5;
          //   newHeight = parseInt(imageEditorWindow.dataset.minHeight, 10) * 0.5;
          // }
        }
        imageEditorWindow.style.width = newWidth + 'px';
        imageEditorWindow.style.height = newHeight + 'px';
        $(imageEditorWindow).find('canvas, .tui-image-editor-canvas-container')
          .css('max-width', imageEditorWindow.style.width)
          .css('max-height', imageEditorWindow.style.height);

        // Save initial size of container
        if (imageEditorWindow.dataset.minHeight === undefined) {
          imageEditorWindow.dataset.minHeight = initHeight;
          imageEditorWindow.dataset.minWidth = initWidth;
        }

         // Calculate scroll offset for new position
        offsetY = (scrollContainer[0].scrollHeight - scrollContainerInitial.height)
        * (mousePosition.top / scrollContainerInitial.height);
        offsetX = (scrollContainer[0].scrollWidth - scrollContainerInitial.width)
        * (mousePosition.left / scrollContainerInitial.width);

        scrollContainer.scrollTop(scrollContainerInitial.top + offsetY);
        scrollContainer.scrollLeft(scrollContainerInitial.left + offsetX);

        e.preventDefault();
        e.stopPropagation();
      }
}

// custome range
customeRange = (imageEditor) => {
	const rangeControls = [imageEditor.ui.draw._els.drawRange,];

	rangeControls.forEach( (tuiRange) => {
    const divWrapper = tuiRange.rangeElement;
    const textBoxInput = tuiRange.rangeInputElement;
    const rangeInput = document.createElement( 'input' );
    rangeInput.type          = 'range';
    rangeInput.min           = tuiRange._min.toString();
    rangeInput.max           = tuiRange._max.toString();
    rangeInput.style.width   = '100%';
    rangeInput.style.display = 'inline-block';
    this.copyInputNumberValue(textBoxInput,rangeInput );
    divWrapper.appendChild( rangeInput );
    rangeInput.addEventListener( 'input', function( ev ) {
      const inp = ev.currentTarget;
      textBoxInput.value = inp.value;
      textBoxInput.dispatchEvent( new Event( 'blur' ) );
    });
    textBoxInput.addEventListener( 'input', function( ev ) {
      this.copyInputNumberValue(textBoxInput,rangeInput );
    });
  
    textBoxInput.type = 'number';
    textBoxInput.min  = rangeInput.min;
    textBoxInput.max  = rangeInput.max;
  
    divWrapper.querySelector( 'div.tui-image-editor-virtual-range-bar' ).style.visibility = 'hidden';
  })
}

  copyInputNumberValue = ( src, dest ) => {
    const valueNum = parseInt( src.value,10 );
    if( isNaN( valueNum ) ) {
      dest.valueAsNumber = parseInt( dest.min );
    }
    else {
      dest.valueAsNumber = valueNum;
    }
  }

  componentWillUnmount() {
    this.imageEditorInst.destroy();
    this.imageEditorInst = null;
  }

  getInstance() {
    return this.imageEditorInst;
  }

  getRootElement() {
    return this.rootEl.current;
  }

  render() {
    return <div className="rounded" ref={this.rootEl} />;
  }
}

export default PhotoGalleryImageEditor;